import { Helmet } from 'react-helmet-async';

export function serverSeoConfig() {
  if (typeof document === 'undefined') return {};
  try { return JSON.parse(document.getElementById('__MELANUA_SEO__')?.textContent || '{}'); }
  catch { return {}; }
}

export default function SeoHead({
  title = "MELANUA® — French-Inspired Luxury Skincare in Australia",
  description = "Discover MELANUA, a French-inspired Australian skincare brand blending nature, science and ritual for radiant, healthy skin.",
  canonical,
  ogType = "website",
  ogImage = "https://melanua.com/static/M_Emblem.png",
  schema,
  breadcrumbs,
  robots,
  exactTitle = false,
  socialTitle
}) {
  const canonicalUrl = canonical || `https://melanua.com${typeof window !== 'undefined' ? window.location.pathname : ''}`;
  const config = serverSeoConfig();
  const page = Object.entries(config.pages || {}).find(([key, value]) => key !== 'not-found' && value.canonical === canonicalUrl)?.[1];
  const resolvedTitle = page?.title || title;
  const fullTitle = exactTitle || resolvedTitle.includes('MELANUA') ? resolvedTitle : `${resolvedTitle} | MELANUA®`;
  const resolvedDescription = page?.description || description;
  const resolvedSchema = canonicalUrl === 'https://melanua.com/' ? (config.home_schema || schema) : schema;
  const resolvedRobots = robots || (page?.noindex ? 'noindex, nofollow' : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <meta name="robots" content={resolvedRobots} />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" href={canonicalUrl} hrefLang="en-au" />
      <link rel="alternate" href={canonicalUrl} hrefLang="x-default" />

      <meta property="og:title" content={socialTitle ?? fullTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:site_name" content="MELANUA®" />
      <meta property="og:locale" content="en_AU" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={socialTitle ?? fullTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      <meta name="twitter:image" content={ogImage} />

      {resolvedSchema && (
        <script type="application/ld+json">
          {JSON.stringify(resolvedSchema)}
        </script>
      )}

      {breadcrumbs && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": breadcrumbs
          })}
        </script>
      )}
    </Helmet>
  );
}
